import React from 'react'
import { useSelector } from 'react-redux'
import { NodeContentProps } from '../../types'
import KeyFigureSelection from '../../../../../../../../components/KeyFigure/KeyFigureSelection'
import { companyFormBasedKeyFigureSelector } from '../../../../../../../../redux/entities/keyFigures/selectors'

const KeyFigureNodeContent: React.FC<NodeContentProps> = ({ node, onUpdateValue }) => {
  const keyFigures = useSelector(companyFormBasedKeyFigureSelector)

  return (
    <div style={{ width: '100%', minWidth: 200, maxWidth: 500 }}>
      <KeyFigureSelection
        keyFigureTranslation="keyFigureStatement"
        onChange={value => onUpdateValue(node.id, { value })}
        selectableKeyFigures={keyFigures}
        selectedKeyfigures={node.value as number[]}
        data-cy={`key-figure-select-${node.id}`}
      />
    </div>
  )
}

export default KeyFigureNodeContent
